module.exports = __webpack_public_path__ + "static/media/step2.36d1c035.png";